import React from "react";
import arrowUpGreen from "../../assets/images/arrow-up-green.png";
import arrowDownRed from "../../assets/images/arrow-down-red.png";
import equalBlue from "../../assets/images/equal-blue.png";

export function ArrowOrEqualIcon({ iconName, width = 12, height = 12 }) {
    const icons = {
        arrowUpGreen: { icon: arrowUpGreen, title: "Aumentou" },
        arrowDownRed: { icon: arrowDownRed, title: "Diminuiu" },
        equalBlue: { icon: equalBlue, title: "Permaneceu o mesmo" },
    };

    if (!iconName || !icons[iconName]) return null;

    return <img style={{ marginLeft: 2 }} src={icons[iconName].icon} width={width} height={height} title={icons[iconName].title} alt="" />;
}
